var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { stringBuilder } from '../util';
const TuxInputGroup = (props) => {
    const { children, disabled = false, id, className, helperText, label, labelClasses, large = false, readonly = false, required = false, small = false } = props, rest = __rest(props, ["children", "disabled", "id", "className", "helperText", "label", "labelClasses", "large", "readonly", "required", "small"]);
    const helperId = helperText ? `helper-${id}` : undefined;
    const labelClassName = stringBuilder('tuxedo_label', { disabled, required }, labelClasses);
    const helperTextClassName = stringBuilder('form-text', { disabled });
    const inputGroupClassName = stringBuilder('input-group', {
        disabled,
        readonly,
        'input-group-sm': small,
        'input-group-lg': large
    }, className);
    return (_jsxs("div", { children: [label && (_jsx("label", Object.assign({ className: labelClassName, htmlFor: id }, { children: label }), void 0)), helperText && (_jsx("small", Object.assign({ className: helperTextClassName, id: helperId }, { children: helperText }), void 0)), _jsx("div", Object.assign({ className: inputGroupClassName }, rest, { children: children }), void 0)] }, void 0));
};
export default TuxInputGroup;
